import { SxProps, Theme } from '@mui/material';

interface SvgTextProps {
  readonly fill: string;
  readonly stroke: string;
  readonly strokeWidth: string;
  readonly textAnchor: string;
  readonly fontSize: string;
}

const FONT_SIZE = '8px';
const STROKE_COLOR = '#cccccc';
const STROKE_WIDTH = '0.5';

export const svgTextStyles: SvgTextProps = {
  fill: 'currentColor',
  stroke: STROKE_COLOR,
  strokeWidth: STROKE_WIDTH,
  textAnchor: 'right',
  fontSize: FONT_SIZE,
} as const;

export const rowContainerStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%',
  padding: '0 5px',
};

export const labelTextStyles: SxProps<Theme> = {
  fontSize: FONT_SIZE,
  color: 'currentColor',
};

export const valueContainerStyles: SxProps<Theme> = {
  fontSize: FONT_SIZE,
  color: 'currentColor',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

export const getValueContainerStyles = (
  isLoading: boolean,
): SxProps<Theme> => ({
  ...valueContainerStyles,
  '& .value-loader-unit, & .value-loader-denominator': {
    display: isLoading ? 'none' : 'inline',
  },
});

export const deviceDataPointsSectionStyles = {
  svgText: svgTextStyles,
  rowContainer: rowContainerStyles,
  labelText: labelTextStyles,
  valueContainer: valueContainerStyles,

  rect: {
    fill: 'transparent',
    stroke: STROKE_COLOR,
    strokeWidth: STROKE_WIDTH,
  } as const,

  foreignObject: {
    valueWidth: 80,
    valueHeight: 20,
    xOffset: 70,
    yOffset: -10,
    rowHeight: 15,
  } as const,

  layout: {
    labelYOffset: -20,
    rectPadding: 5,
    rectWidth: 155,
    rectBottomPadding: 10,
    rowSpacing: 15,
  } as const,
} as const;
